// 01.01.引入Axios
import axios from "axios"
// 01.03.引入QS
import qs from "qs"
// 01.04.引入Element Message
import {ElMessage} from 'element'
// 01.05.引入Router路由
import Router from "../router"

// 02.Axios相关配置
// 02.01.API接口地址
// 02.01.01.API正式接口地址
axios.defaults.baseURL = 'http://sxgsxx.com/'
// 02.01.01.API开发接口地址
// axios.defaults.baseURL = 'http://localhost:8000/'
// 02.02.POST请求头
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"
axios.defaults.headers.get["Content-Type"] = "application/x-www-form-urlencoded"
// 02.03.超时相应时间
axios.defaults.timeout = 10000



// 03.请求拦截器（ Request ）
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('Token')
        if (token) {
            config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'token': token
            }
        }
        return config
    },
    error => {
        return Promise.error(error)
    }
)


// 04.响应拦截器（ Response ）
axios.interceptors.response.use(
    response => {
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        if (!error.response) {
            ElMessage.error('API无响应，请联系系统管理员')
        } else {
            if (error.response.status) {
                if (error.response.status === 401 || error.response.status === 402) {
                    Router.push('/login')
                    return Promise.reject(error)
                } else {
                    return Promise.reject(error)
                }
            }
        }
    }
)

// 05.API请求类 ( POST GET )
export default {
    // 05.01.API POST请求 ( POST )
    post(url, data) {
        return new Promise((resolve, reject) => {
            axios.post(url, qs.stringify(data, {arrayFormat: 'brackets'})).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    },
    // 05.02.API GET请求 ( GET )
    get(url, data) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: data,
            }).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    },
}


